import { GET_APPROVAL_ATTENDANCE } from "@/store/modules/mutation-types";

export default {
  actions: {
    async [GET_APPROVAL_ATTENDANCE]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/approval_attendances",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  }
};
